<template>
  <div class="task" v-if="task.enabled">

    <b-card class="my-1">
      <template v-slot:header>
        <h6 class="mb-0">{{task.name}}</h6>
      </template>
      <b-card-text>
        <Action v-for="action in task.actions" :key="action.id" v-bind:action="action"></Action>
      </b-card-text>
    </b-card>

  </div>
</template>

<script>
import Action from '@/components/Action'

export default {
  name: 'Task',
  props: ['task'],
  components: {
    Action
  },
  computed: {

  }
}
</script>

<style scoped>

</style>
